import AdminCompoffLeaverequest from "../Admin/AdminCompoffLeaverequest";
import AdminEmployeeList from "../Admin/AdminEmployeeList";
import AdminEmployeeSpecificView from "../Admin/AdminEmployeeSpecificView";
import AdminLeaverequest from "../Admin/AdminLeaverequest";
import AdminOverallReport from "../Admin/AdminOverallReport";
import AdminPerformanceList from "../Admin/AdminPerformanceList";
import AdminPerformanceSpecificView from "../Admin/AdminPerformanceSpecificView";
import AdminPropertyReport from "../Admin/AdminPropertyReport";
import AdminReportList from "../Admin/AdminReportList";
import AdminSpecificComprequestview from "../Admin/AdminSpecificComprequestview";
import AdminSpecificrequestview from "../Admin/AdminSpecificrequestview";
import Dashboard from "../Dashboard";
import DirectorCompoffLeaverequest from "../Director/DirectorCompoffLeaverequest";
import DirectorEmployeeList from "../Director/DirectorEmployeeList";
import DirectorEmployeeSpecificView from "../Director/DirectorEmployeeSpecificView";
import DirectorIndentlistrequest from "../Director/DirectorIndentlistrequest";
import DirectorIndentspecificsview from "../Director/DirectorIndentspecificview";
import DirectorLeaverequest from "../Director/DirectorLeaverequest";
import Directoroverallreport from "../Director/DirectorOverallreport";
import DirectorPerformanceList from "../Director/DirectorPerformanceList ";
import DirectorPerformanceSpecificView from "../Director/DirectorPerformanceSpecificView";
import DirectorReportlist from "../Director/DirectorReportList";
import DirectorScoreReport from "../Director/DirectorScoreReport";
import DirectorScoreReportGenerate from "../Director/DirectorScoreReportGenerate";
import DirectorScoreReportSpecificview from "../Director/DirectorScoreReportSpecificview";
import DirectorSpecificComprequestview from "../Director/DirectorSpecificComprequestview";
import DirectorSpecificrequestview from "../Director/DirectorSpecificrequestview";
import HodAPAReportGenerate from "../Hod/HodAPAReportGenerate";
import HodAnnualPerformanceReport from "../Hod/HodAnnualPerformanceReport";
import HodCompoffLeaverequest from "../Hod/HodCompoffLeaverequest";
import HodEmployeeList from "../Hod/HodEmployeeList";
import HodEmployeeSpecificView from "../Hod/HodEmployeeSpecificView";
import HodIndentspecificsview from "../Hod/HodIndentSpecificView";
import HodIndentformrequest from "../Hod/HodIndentformrequest";
import HodLeaverequest from "../Hod/HodLeaverequest";
import HodPerformanceList from "../Hod/HodPerformanceList";
import HodPerformanceSpecificView from "../Hod/HodPerformanceSpecificView";
import HodReportList from "../Hod/HodReportList";
import HodReportOverall from "../Hod/HodReportOverall";
import HodReportSpecificView from "../Hod/HodReportSpecificView";
import HodSpecificComprequestview from "../Hod/HodSpecificComprequestview";
import HodSpecificrequestview from "../Hod/HodSpecificrequestview";
import IndentApplication from "../Indent/IndentApplication";
import IndentForm from "../Indent/IndentForm";
import IndentSpecificView from "../Indent/IndentSpecificView";
import Profile from "../Profile";
import StaffActivityReport from "../Staff/StaffActivityReport";
import StaffActivityReportPage from "../Staff/StaffActivityReportPage";
import StaffOverallreport from "../Staff/StaffOverallReport";
import StaffPerformance from "../Staff/StaffPerformance";
import StaffPerformanceSpecific from "../Staff/StaffPerformanceSpecific";
import StaffPerformanceSpecificView from "../Staff/StaffPerformanceSpecificView";
import StaffPropertyReport from "../Staff/StaffPropertyReport";
import StaffPropertyReportUpload from "../Staff/StaffPropertyReportUpload";
import StaffScoreReport from "../Staff/StaffScoreReport";
import StaffScoreReportApply from "../Staff/StaffScoreReportApply";
import StaffScoreReportGenerate from "../Staff/StaffScoreReportGenerate";
import StaffScoreReportSpecificview from "../Staff/StaffScoreReportSpecificview";
import StaffSpecificView from "../Staff/StaffSpecificView";
import Staffattendance from "../Staff/Staffattendance";
import Staffcompoff from "../Staff/Staffcompoff";
import Staffleavestatus from "../Staff/Staffleavestatus";
import Staffleaveapply from "../Staff/staffleaveapply";
import StoreInchargeIndentList from "../Stores/StoreInchargeIndentList";
import StoreInchargeIndentSpecificView from "../Stores/StoreInchargeIndentSpecificView";
import StoreMaster from "../Stores/StoreManagement/StoreMaster";
import StoreProductspecificview from "../Stores/StoreProductSpecificView";
import Masterdata from "../SystemAdmin/Masterdata/Masterdata";
import SystemadminEmployeeList from "../SystemAdmin/SystemadminEmployeeList";
import SystemadminEmployeeSpecificView from "../SystemAdmin/SystemadminEmployeeSpecificView";
import SystemadminEmployeechildspecific from "../SystemAdmin/SystemadminEmployeechildspecific";
import SystemadminEmployeeleavespecific from "../SystemAdmin/SystemadminEmployeeleavespecific";
import SystemadminLeaveRestriction from "../SystemAdmin/SystemadminLeaveRestriction";

export const routes = [
    { path: '/dashboard', element: Dashboard },
    { path: '/Profile', element: Profile },
    { path: '/Staff/Staffleaveapply', element: Staffleaveapply },
    { path: '/Staff/Staffleavestatus', element: Staffleavestatus },
    { path: '/Staff/StaffSpecificView/:id', element: StaffSpecificView },
    { path: '/Staff/Staffattendance', element: Staffattendance },
    { path: '/Staff/Staffcompoff', element: Staffcompoff },
    { path: '/Staff/StaffActivityReportPage', element: StaffActivityReportPage },
    { path: '/Staff/StaffActivityReport', element: StaffActivityReport },
    { path: '/Staff/StaffActivitySpecificReport/:id', element: StaffActivityReport },
    { path: '/Staff/StaffSavedReport/:id', element: StaffActivityReport },
    { path: '/Staff/StaffOverallreport', element: StaffOverallreport },
    { path: '/Staff/StaffScoreReport', element: StaffScoreReport },
    { path: '/Staff/StaffScoreReportApply', element: StaffScoreReportApply },
    { path: '/Staff/StaffPerformanceReport', element: StaffPerformance },
    { path: '/Staff/StaffPerformanceSpecificReport/:id', element: StaffPerformanceSpecific },
    { path: '/Staff/StaffPerformanceSpecificViewReport/:id', element: StaffPerformanceSpecificView },
    { path: '/Staff/StaffScoreReportSpecificview/:id', element: StaffScoreReportSpecificview },
    { path: '/Staff/StaffScoreReportGenerate', element: StaffScoreReportGenerate },
    { path: '/Hod/HodLeaverequest', element: HodLeaverequest },
    { path: '/Hod/HodSpecificrequestview/:id', element: HodSpecificrequestview },
    { path: '/Hod/HodCompoffLeaverequest', element: HodCompoffLeaverequest },
    { path: '/Hod/HodSpecificComprequestview/:id', element: HodSpecificComprequestview },
    { path: '/Hod/HodEmployeeList', element: HodEmployeeList },
    { path: '/Hod/HodEmployeeSpecificView/:id', element: HodEmployeeSpecificView },
    { path: '/Hod/HodIndentformrequest', element: HodIndentformrequest },
    { path: '/Hod/HodIndentspecificsview/:id', element: HodIndentspecificsview },
    { path: '/Hod/HodReportlist', element: HodReportList },
    { path: '/Hod/StaffPerformanceReport', element: HodPerformanceList },
    { path: '/Hod/AnnualPerformanceAssessmentReport', element: HodAnnualPerformanceReport },
    { path: '/Hod/AnnualPerformanceAssessmentReport/:id', element: HodAPAReportGenerate },
    { path: '/Director/AnnualPerformanceAssessmentReport/:id', element: HodAPAReportGenerate },
    { path: '/admin/AnnualPerformanceAssessmentReport/:id', element: HodAPAReportGenerate },
    { path: '/Hod/Generate/AnnualPerformanceAssessmentReport', element: HodAPAReportGenerate },
    { path: '/admin/AnnualPerformanceAssessmentReport', element: HodAnnualPerformanceReport },
    { path: '/admin/Generate/AnnualPerformanceAssessmentReport', element: HodAPAReportGenerate },
    { path: '/Director/AnnualPerformanceAssessmentReport', element: HodAnnualPerformanceReport },
    { path: '/Director/Generate/AnnualPerformanceAssessmentReport', element: HodAPAReportGenerate },
    { path: '/admin/StaffPerformanceReport', element: AdminPerformanceList },
    { path: '/admin/AdminReportlist', element: AdminReportList },
    { path: '/admin/AdminLeaverequest', element: AdminLeaverequest },
    { path: '/admin/AdminSpecificrequestview/:id', element: AdminSpecificrequestview },
    { path: '/admin/AdminCompoffLeaverequest', element: AdminCompoffLeaverequest },
    { path: '/admin/AdminSpecificComprequestview/:id', element: AdminSpecificComprequestview },
    { path: '/admin/AdminEmployeeList', element: AdminEmployeeList },
    { path: '/admin/AdminEmployeeSpecificView/:id', element: AdminEmployeeSpecificView },
    { path: '/Director/DirectorLeaverequest', element: DirectorLeaverequest },
    { path: '/Director/DirectorSpecificrequestview/:id', element: DirectorSpecificrequestview },
    { path: '/Director/DirectorCompoffLeaverequest', element: DirectorCompoffLeaverequest },
    { path: '/Director/DirectorSpecificComprequestview/:id', element: DirectorSpecificComprequestview },
    { path: '/Director/DirectorEmployeeList', element: DirectorEmployeeList },
    { path: '/Director/DirectorEmployeeSpecificView/:id', element: DirectorEmployeeSpecificView },
    { path: '/Director/DirectorIndentlistrequest', element: DirectorIndentlistrequest },
    { path: '/Director/DirectorIndentspecificsview/:id', element: DirectorIndentspecificsview },
    { path: '/Director/DirectorReportlist', element: DirectorReportlist },
    { path: '/Director/StaffPerformanceReport', element: DirectorPerformanceList },
    { path: '/Director/Directorreportspecificview/:id', element: HodReportSpecificView },
    { path: '/Hod/Hodreportspecificview/:id', element: HodReportSpecificView },
    { path: '/Hod/HodPerformancereportspecificview/:id', element: HodPerformanceSpecificView },
    { path: '/Director/StaffPerformancereportspecificview/:id', element: DirectorPerformanceSpecificView },
    { path: '/admin/AdminPerformancereportspecificview/:id', element: AdminPerformanceSpecificView },
    { path: '/admin/adminreportspecificview/:id', element: HodReportSpecificView },
    { path: '/Director/Directoroverallreport', element: Directoroverallreport },
    { path: '/Hod/Hodoverallreport', element: HodReportOverall },
    { path: '/admin/adminoverallreport', element: AdminOverallReport },
    { path: '/Director/DirectorScoreReport', element: DirectorScoreReport },
    { path: '/Director/DirectorScoreReportSpecificview/:id', element: DirectorScoreReportSpecificview },
    { path: '/Director/DirectorScoreReportGenerate', element: DirectorScoreReportGenerate },
    { path: '/admin/AdminScoreReport', element: DirectorScoreReport },
    { path: '/admin/AdminScoreReportSpecificview/:id', element: DirectorScoreReportSpecificview },
    { path: '/admin/AdminScoreReportGenerate', element: DirectorScoreReportGenerate },
    { path: '/Hod/HodScoreReportSpecificview/:id', element: DirectorScoreReportSpecificview },
    { path: '/Hod/HodScoreReportGenerate', element: DirectorScoreReportGenerate },
    { path: '/Hod/HodScoreReport', element: DirectorScoreReport },
    { path: '/Systemadmin/Masterdata', element: Masterdata },
    { path: '/Systemadmin/SystemadminEmployeeList', element: SystemadminEmployeeList },
    { path: '/Systemadmin/SystemadminEmployeeSpecificView/:id', element: SystemadminEmployeeSpecificView },
    { path: '/Systemadmin/SystemadminEmployeeleavespecific/:id', element: SystemadminEmployeeleavespecific },
    { path: '/Systemadmin/SystemadminEmployeechildspecific/:id', element: SystemadminEmployeechildspecific },
    { path: '/Systemadmin/SystemadminLeaveRestriction/:id', element: SystemadminLeaveRestriction },
    { path: '/Indent/IndentApplication', element: IndentApplication },
    { path: '/Indent/IndentSpecificView/:id', element: IndentSpecificView },
    { path: '/Indent/IndentForm', element: IndentForm },
    { path: '/Stores/StoreMaster', element: StoreMaster },
    { path: '/Stores/StoreProductspecificview/:id', element: StoreProductspecificview },
    { path: '/Stores/StoreInchargeIndentList', element: StoreInchargeIndentList },
    { path: '/Stores/StoreInchargeIndentSpecificView/:id', element: StoreInchargeIndentSpecificView },
    { path: '/propertyreport', element: StaffPropertyReport },
    { path: '/upload/propertyreport', element: StaffPropertyReportUpload },
    { path: '/admin/propertyreturnsreport', element: AdminPropertyReport },
];
